(function () {
  function initConsentBlock(block) {
    var form = block.closest('form');
    if (!form) return;

    var checks = block.querySelectorAll('.tradility-consent__check');
    var errorEl = block.querySelector('[data-consent-error]');
    var tsInput = form.querySelector('input[name="properties[_consent_timestamp]"]');
    var immInput = form.querySelector('input[name="properties[_consent_immediate_performance]"]');
    var bull500Input = form.querySelector('input[name="properties[_consent_bull500_risk]"]');

    // Buttons to gate.
    var productForm = form.closest('product-form');
    var submitBtn = (productForm || form).querySelector('[type="submit"]');
    var acceleratedWrap = (productForm || form).querySelector('shopify-accelerated-checkout');

    function allChecked() {
      var ok = checks.length > 0;
      checks.forEach(function (c) { if (!c.checked) ok = false; });
      return ok;
    }

    function lock() {
      if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
      if (acceleratedWrap) {
        acceleratedWrap.style.pointerEvents = 'none';
        acceleratedWrap.style.opacity = '0.5';
        acceleratedWrap.setAttribute('aria-disabled', 'true');
      }
      if (tsInput) tsInput.value = '';
      if (immInput) immInput.value = '';
      if (bull500Input) bull500Input.value = '';
    }

    function unlock() {
      if (submitBtn) submitBtn.removeAttribute('aria-disabled');
      if (acceleratedWrap) {
        acceleratedWrap.style.pointerEvents = '';
        acceleratedWrap.style.opacity = '';
        acceleratedWrap.removeAttribute('aria-disabled');
      }
      if (tsInput) tsInput.value = new Date().toISOString();
      if (immInput) immInput.value = 'true';
      if (bull500Input) bull500Input.value = 'true';
      if (waiverInput) waiverInput.value = 'true';
      if (errorEl) errorEl.hidden = true;
    }

    function sync() { if (allChecked()) { unlock(); } else { lock(); } }

    checks.forEach(function (c) { c.addEventListener('change', sync); });

    // Backstop: block submit if consent not given.
    form.addEventListener('submit', function (evt) {
      if (!allChecked()) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (errorEl) errorEl.hidden = false;
        block.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true); // capture phase so it runs before product-form's listener

    lock(); // initial locked state
  }

  function init() {
    document.querySelectorAll('[data-tradility-consent]').forEach(initConsentBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
